import React, { useState, useEffect } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from './Icons';
import './filterComponents.css';

const CollapsibleFilterContainerTW = ({ filterName, children, className = '', isExpanded: externalExpanded, onToggle }) => {
    const [isExpanded, setIsExpanded] = useState(externalExpanded || false);

    // Synchronize with external expanded state when it changes
    useEffect(() => {
        if (externalExpanded !== undefined) {
            setIsExpanded(externalExpanded);
        }
    }, [externalExpanded]);

    const toggleExpand = () => {
        const newExpandedState = !isExpanded;
        setIsExpanded(newExpandedState);

        // Notify parent component if callback provided
        if (onToggle) {
            onToggle(newExpandedState);
        }
    };

    return (
        <div className={`collapsible-container filter-components ${className}`}>
            <button
                className={`filter-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpand}
                aria-expanded={isExpanded}
            >
                <span className="font-medium">{filterName}</span>
                {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </button>

            {isExpanded && (
                <div className="p-3 border-t border-gray-200 bg-white w-full" style={{ overflow: 'visible' }}>
                    {children}
                </div>
            )}
        </div>
    );
};

export { CollapsibleFilterContainerTW };
